import classNames from "classnames";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Icon } from "../../graphic/Icon";
import styles from "./SiteStoryTryTag.scss";

const msgKey = "siteStoryTryTag";

/**
 * "Try it" tag on an interactive story, which becomes a reset button once the visitor has changed something.
 * SiteStoryStage shows it in its top left corner (with `onReset`); a story can also place it itself (`className`).
 * @param changed – the visitor has changed something in the story
 * @param onReset – brings the story back to how it started
 */
export const SiteStoryTryTag = ({ changed, onReset, className }) => {
    return changed ? (
        <button type="button" className={classNames(styles.base, styles.reset, className)} onClick={onReset}>
            <Icon name="reset" />
            <FormattedMessage id={`${msgKey}.reset`} />
        </button>
    ) : (
        <span className={classNames(styles.base, className)} aria-hidden="true">
            <Icon name="hand" />
            <FormattedMessage id={`${msgKey}.tryIt`} />
        </span>
    );
};
